import { TReconnectConfig } from '../../types/reconnection-config';
import { EventbriteServiceComponent } from './EventbriteServiceComponent';

export const EventbriteReconnectionConfig: TReconnectConfig = {
  serviceComponent: EventbriteServiceComponent,
};
